import { Component, ViewEncapsulation, input, computed, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'ds-text-block',
  templateUrl: './text-block.html',
  styleUrl: './text-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [NgOptimizedImage],
})
export class TextBlockComponent {
  private readonly sanitizer = inject(DomSanitizer);
  readonly layout = input<'prose' | 'split-left' | 'split-right'>('prose');
  readonly mediaSrc = input<string>('');
  readonly mediaAlt = input<string>('');
  readonly mediaWidth = input<number>(0);
  readonly mediaHeight = input<number>(0);
  readonly body = input<string>('');
  readonly trustedBody = computed<SafeHtml | null>(() => {
    const html = this.body();
    return html ? this.sanitizer.bypassSecurityTrustHtml(html) : null;
  });
}
